var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pageRoot"}},[_c('letter-picker',{staticStyle:{"top":"60px","left":"30px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }